export default __webpack_public_path__ + "static/media/illustration-algocare-m@2x.c73e67dc.png";